import type { HtmlString } from '~/Features/Types/HtmlString.csharp';

export function isHtmlString(content: unknown): content is HtmlString {
    return !!content && typeof content === 'object' && 'value' in content && typeof content.value === 'string';
}
